<script lang="ts">
    import { _ } from 'svelte-i18n';
    import type { ImportAnalyzeResponseType } from '../../ColumnSelectPro/ColumnSettingsApi';
    import ImportAnalyzeByCategoryRow from './ImportAnalyzeByCategoryRow.svelte';
    import './ImportAnalyzeByCategoryRow.css';
    import { fade } from 'svelte/transition';

    export let analyze: ImportAnalyzeResponseType;
    export let showByCategory: boolean = false;

    let allCategories = getAllCategories();

    function getAllCategories() {
        let allCategories = [];
        for (let key in analyze.added.by_category) {
            allCategories.push(key);
        }
        for (let key in analyze.changed.by_category) {
            allCategories.push(key);
        }
        for (let key in analyze.unchanged.by_category) {
            allCategories.push(key);
        }
        for (let key in analyze.removed.by_category) {
            allCategories.push(key);
        }
        return allCategories.filter((value, index, self) => self.indexOf(value) === index);
    }
</script>

<div style="width: 100%;">
    <div class="import-analyze-by-category-row import-analyze-by-category-header">
        <div class="import-analyze-by-category-row-label"></div>
        <div class="import-analyze-by-category-row-count">{$_('New')}</div>
        <div class="import-analyze-by-category-row-count">{$_('Changed')}</div>
        <div class="import-analyze-by-category-row-count">{$_('Unchanged')}</div>
        <div class="import-analyze-by-category-row-count">{$_('Removed items')}</div>
    </div>
    {#if showByCategory}
        <div
            in:fade={{ duration: 200 }}
            out:fade={{ duration: 200 }}
            style="max-height: 200px;
overflow: auto;"
        >
            {#each allCategories as category}
                <ImportAnalyzeByCategoryRow
                    label={category}
                    added={analyze.added.by_category[category]}
                    changed={analyze.changed.by_category[category]}
                    unchanged={analyze.unchanged.by_category[category]}
                    removed={analyze.removed.by_category[category]}
                />
            {/each}
        </div>
    {/if}
    <ImportAnalyzeByCategoryRow
        bold={true}
        label={$_('Sum')}
        added={analyze.added.count}
        changed={analyze.changed.count}
        unchanged={analyze.unchanged.count}
        removed={analyze.removed.count}
    />
</div>
